// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"5657":"home-d87c119a","9884":"admin"}[chunkId] + "." + {"5657":"dc9d60c3","9884":"7b1d2020"}[chunkId] + ".css";
};